// extracted by mini-css-extract-plugin
module.exports = {"upper-row":"_32bbee5fda--upper-row--rigr_","lower-row":"_32bbee5fda--lower-row--Oag8x"};